import React from "react";

import { ErrorModalButton, MessageTextContainer } from "./styles";

export const getMessageText = (
    uploadsInDropzoneCount = 0,
    allFailedUploadsCount = 0,
    currentlyProcessingCount = 0,
    openErrorModal
) => {
    const handleSeeDetailsClick = () => openErrorModal();

    // if all uploads have failed, show this message
    if (
        uploadsInDropzoneCount === 0 &&
        !!allFailedUploadsCount &&
        currentlyProcessingCount === 0
    ) {
        return (
            <MessageTextContainer>
                No photos uploaded. {getFailedText(allFailedUploadsCount)}
                <ErrorModalButton onClick={handleSeeDetailsClick}>
                    See details
                </ErrorModalButton>
            </MessageTextContainer>
        );
    }

    return (
        <MessageTextContainer>
            {getSuccessText(uploadsInDropzoneCount)}{" "}
            {getFailedText(allFailedUploadsCount)}{" "}
            {getProcessingText(currentlyProcessingCount)}
            {!!allFailedUploadsCount && !currentlyProcessingCount && (
                <ErrorModalButton onClick={handleSeeDetailsClick}>
                    See details
                </ErrorModalButton>
            )}
        </MessageTextContainer>
    );
};

const getSuccessText = (uploadsInDropzoneCount = 0) => {
    if (uploadsInDropzoneCount < 1) return "";
    return `${uploadsInDropzoneCount} uploaded successfully.`;
};

const getFailedText = (allFailedUploadsCount = 0) => {
    if (allFailedUploadsCount < 1) return "";
    if (allFailedUploadsCount === 1) return `1 error.`;
    return `${allFailedUploadsCount} errors.`;
};

const getProcessingText = (currentlyProcessingCount = 0) => {
    if (currentlyProcessingCount < 1) return "";
    return `Processing ${currentlyProcessingCount} more. This may take a while.`;
};
